const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Clipboard {
    constructor(runtime) { this.runtime = runtime; this._last = ''; }
    getInfo() {
        return {
            id: 'clipboardExt', name: '📋 クリップボード', color1: '#00BCD4', color2: '#00ACC1',
            blocks: [
                { opcode: 'copy', blockType: BlockType.COMMAND, text: '[T] をコピー', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello!' } } },
                { opcode: 'paste', blockType: BlockType.REPORTER, text: 'クリップボードの内容' }
            ]
        };
    }
    copy(args) { this._last = Cast.toString(args.T); try { navigator.clipboard.writeText(this._last); } catch(e) {} }
    paste() { return this._last; }
}
module.exports = Scratch3Clipboard;